import React from 'react';
import Navbar from './Navbar';
import LanguageToggle from './LanguageToggle';
import ThemeToggle from './ThemeToggle';
import { useLanguage } from '../../context/LanguageContext';

const Header = () => {
  const { t } = useLanguage();

  return (
    <header>
      {/* Top utility bar */}
      <div className="cf-topbar">
        <div className="container d-flex justify-content-between align-items-center">
          <span>
            <i className="bi bi-globe2 me-1"></i>
            {t('topbar')}
          </span>
          <div className="d-flex align-items-center gap-2">
            <LanguageToggle />
            <ThemeToggle />
          </div>
        </div>
      </div>
      {/* Main navbar */}
      <Navbar />
    </header>
  );
};

export default Header;
